<template>
  <div class="max-w-7xl mx-auto pb-20">
    <TypeDisplay
      :variant="$options.Typography.Display.TERA"
      :weight="$options.Typography.Weights.REGULAR"
    >
      {{ hipaa.main_header }}
    </TypeDisplay>
    <ul>
      <li
        v-for="(section, index) in hipaa.sections"
        :key="`hipaa-section-${index}`"
        class="mb-8"
      >
        <TypeHeading
          :variant="$options.Typography.Heading.HEADLINE"
          :weight="$options.Typography.Weights.REGULAR"
          tag="p"
          class="section-header mb-4"
        >
          {{ section.header }}
        </TypeHeading>
        <p v-html="section.content" />
      </li>
    </ul>
    <TypeDisplay
      :variant="$options.Typography.Display.MEGA"
      :weight="$options.Typography.Weights.STRONG"
      tag="p"
      class="footer-outro text-center"
    >
      <p v-html="hipaa.outro"></p>
    </TypeDisplay>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { TypeDisplay, TypeHeading, constants } from '@bambeehr/pollen';
import { hipaa } from '@/modules/InformationPages/Legal/mocks/index';
const { Typography } = constants;

export default defineComponent({
  name: 'HipaaInfo',
  Typography,
  components: { TypeDisplay, TypeHeading },
  setup() {
    return { hipaa };
  },
});
</script>

<style scoped>
h1 {
  @apply text-black font-bold;

  font-size: 30px;
}
.section-header {
  @apply text-black;

  font-size: 32px;
}
ul {
  list-style: none;
  margin-top: 1.5rem;
}
li {
  @apply text-black font-medium;

  color: #908b97;
  font-size: 18px;
  line-height: 2;
}
p.subheader {
  @apply text-black;
}
ol li {
  font-size: 1.25rem;
  font-weight: 500;
  padding-left: 2rem;
  text-indent: -18px;
}
li ul {
  list-style-position: inside;
  list-style-type: disc;
  padding-left: 1rem;
}
li ul li {
  color: #908b97;
  font-size: 16px;
  line-height: 2;
  text-indent: -17px;
}
p >>> div p.subheader {
  @apply text-black font-bold;

  font-size: 22px;
}
p >>> ol {
  list-style-position: inside;
  list-style-type: lower-alpha;
  margin-bottom: 1rem;
  padding-left: 18px;
}
p >>> div ol {
  padding-left: 1rem;
}

li ol.no_bullet {
  padding-left: 0;
}
li ol.no_bullet li {
  text-indent: 0;
}

.footer-outro {
  font-size: 1.125rem;
  font-weight: 700;
  margin-top: 2rem;
  text-align: center;
}
</style>
